import { HsVector2 } from '../../math-new/objects/vector2.class';
import { HsControlActionType } from './control-action-type.enum';
import { HsControlAction } from './control-action.abstract';

export class HsScrollControlAction extends HsControlAction {
  public readonly actionType: HsControlActionType = HsControlActionType.Scroll;
  constructor(public position: HsVector2 = new HsVector2(0, 0), public scrollDelta: number = 0) {
    super();
  }

  public getValuesFrom(controlAction: HsControlAction): void {
    if (!(controlAction instanceof HsScrollControlAction)) {
      return;
    }

    this.scrollDelta = (this.isActive ? this.scrollDelta : 0) + controlAction.scrollDelta;
    this.position.copy(controlAction.position);
    this.isActive = this.scrollDelta !== 0;
  }
}
